import { create } from 'zustand'
import { devtools } from "zustand/middleware";

const useBillingCenters = (set) => ({
    items: [],
    setItems: (payload) => set(() => ({ items: payload }))
})

export default create(devtools(useBillingCenters))